import useSessionInfo from './useSessionInfo';
import type { Perm, PermKey, UserPerms } from '@/modes/common/gql';

export default function usePerms(): UserPerms {
  const { perms } = useSessionInfo();

  return perms;
}

export function usePerm(permKey: PermKey): Perm[] {
  const perms = usePerms();

  return perms[permKey] ?? [];
}

export function useHasPerm(permKey: PermKey, perm: Perm): boolean {
  const resourcePerms = usePerm(permKey);

  return resourcePerms.includes(perm);
}
